import { styled } from "@mui/system";
import { useHideGraphs } from "../hooks/useHideGraphs";
import { Colors } from "../util/Colors";

type IProps = {
    systole?: number;
    diastole?: number;
    valueAlignment?: "left" | "center" | "right";
};

const CenterContainer = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

const Bar = styled("div")({
    height: 12,
    width: 69,
});

export const BloodpressureValueDisplay = ({ systole, diastole, valueAlignment = "center" }: IProps) => {
    const hideGraphs = useHideGraphs();

    if (typeof systole !== "number" || typeof diastole !== "number") {
        return <>-</>;
    }

    const isNormal = systole < 130 && diastole < 80;

    return (
        <CenterContainer style={{ flexDirection: hideGraphs ? "column" : "row" }}>
            <div
                style={{
                    marginRight: hideGraphs ? 0 : 16,
                    marginBottom: hideGraphs ? 4 : 0,
                    whiteSpace: "nowrap",
                    minWidth: 120,
                    textAlign: valueAlignment,
                }}
            >
                &lt; 130/80
            </div>
            <CenterContainer style={{ border: `1px solid ${Colors.GREY_200}` }}>
                <Bar style={{ backgroundColor: isNormal ? Colors.VALUE_DISPLAY_GREEN : undefined }} />
                <Bar style={{ backgroundColor: !isNormal ? Colors.VALUE_DISPLAY_ORANGE : undefined }} />
            </CenterContainer>
        </CenterContainer>
    );
};
